import * as React from "react";
import type { SVGProps } from "react";
const SvgPinInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pin-info_svg__a)">
      <path d="M12 22a1 1 0 0 1-.72-.3C10.54 20.93 4 14.07 4 10a8 8 0 0 1 16 0c0 4.12-6.54 11-7.28 11.75A1 1 0 0 1 12 22m0-18a6 6 0 0 0-6 6c0 2.5 3.84 7.22 6 9.59 2.16-2.37 6-7.09 6-9.59a6 6 0 0 0-6-6" />
      <path d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1" />
      <path d="M12 10h-2a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2M14 15h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2M12 7h-.2a.6.6 0 0 1-.18-.06.8.8 0 0 1-.18-.09 2 2 0 0 1-.15-.12 1.2 1.2 0 0 1-.21-.33A1 1 0 0 1 11 6a1.05 1.05 0 0 1 .29-.71l.15-.12a.8.8 0 0 1 .18-.09.6.6 0 0 1 .18-.08.9.9 0 0 1 .4 0 .6.6 0 0 1 .18.06.8.8 0 0 1 .18.09l.15.12a1 1 0 0 1 .21.33 1 1 0 0 1 0 .78 1 1 0 0 1-.21.33 2 2 0 0 1-.15.12.8.8 0 0 1-.18.09.6.6 0 0 1-.18.06z" />
    </g>
    <defs>
      <clipPath id="pin-info_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPinInfo;
